export function adaptFeature(feature) {
    // reformat data for render
    const linkExplain = !!feature.links ? feature.links.find(l => l.type === 'explain') : null;
    return {
        name: feature.name,
        code: feature.code,
        form: feature.form,
        description: feature.description || feature.descr,
        type: feature.category[0].name,
        version: feature.version,
        link: feature.vendor?.url,
        linkExplain: linkExplain,
        suggested: !!feature.suggested,
        ram: (!!feature.ram || feature.ram === 0) && !isNaN(parseFloat(feature.ram)) ? parseFloat(feature.ram) : 0,
        storage: (!!feature.disk_size || feature.disk_size === 0) && !isNaN(parseFloat(feature.disk_size)) ? parseFloat(feature.disk_size) : 0,
        _id: feature._id,
    }
}

export function processFeatures(currentApp, subscriptions, custom) {
    let _features = [];
    // get features from subscription
    subscriptions.map(subscription => {
        _features.push({
            ...subscription,
            ...{
                category: [{name: 'subscriptions'}],
                disk_size: subscription.disk,
            },
            ...(custom ? {description: subscription.description || subscription.descr} : {}),
        })
    });

    const {features} = currentApp;
    // get features from app
    if (!!features?.length) {
        _features = [...features, ..._features].filter(feature => {
            let avoidRender = feature.avoid_render;
            return (
                // exclude features, that activates automatically by backend
                !feature.autodeploy
                // exclude features that shouldn't be rendered with current app
                && (
                    !avoidRender?.length
                    || !!avoidRender?.length && !avoidRender.includes(currentApp.code)
                )
                // check if data is valid
                && !!feature?.category?.[0]?.name
            )
        });
    }

    if (!custom) {
        _features = _features.map(f => adaptFeature(f));
    } else {
        _features = _features.map(f => ({...f, ...{cpu: !isNaN(parseFloat(f.cpu)) ? parseFloat(f.cpu) : 0}}));
    }
    // create dependency tree
    let dependencies = [];
    features?.map(feature => {
        feature.dependency?.map(masterCode => {
            // check if master feature is excluded from data
            if (!_features.some(f => f.code === masterCode)) return;
            // if master feature already exists in dependency tree, avoid creating new one
            let masterFeature = dependencies.find(d => d.code === masterCode);
            let dependentData = _features.find(f => f.code === feature.code);

            if (dependentData) {
                if (masterFeature) {
                    masterFeature.dependents.push(dependentData)
                } else {
                    let masterFeatureData = _features.find(f => f.code === masterCode);
                    dependencies.push({
                        ...masterFeatureData,
                        ...{dependents: [dependentData]}
                    })
                }
            }
        })
    });

    return {
        features: _features,
        dependencies,
    };
}